module.exports = __webpack_public_path__ + "static/media/jeeves_wedding_bells.91d6eac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/jeeves_wedding_bells.jpg
// module id = 110
// module chunks = 0